import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";

import populixLogo from "./populix-logo.png";
import "./App.css";
import IndonesiaGeoChart from "./IndonesiaGeoChart";
import Table from "./Table";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    borderBottom: "solid 1px #BDBDBD",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function App() {
  const classes = useStyles();

  return (
    <div className="App">
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <a href="https://www.populix.co">
              <img src={populixLogo} alt="populix-logo" width="100" />
            </a>
          </IconButton>
            <div style={{
                fontSize: 24,
                top: -3,
                position: 'relative',
                fontWeight: 700,
                color: 'rgba(16, 73, 109, 1)'
            }}>
                Indonesia COVID-19 Tracker
            </div>
        </Toolbar>
      </AppBar>

      <IndonesiaGeoChart width="960" height="600" />
      <Table />
    </div>
  );
}

export default App;
